import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['table'];

  download() {
    let csv = [];
    const rows = this.tableTarget.querySelectorAll('tr');

    for (const rowElement of rows) {
      if (rowElement.style.display != 'none') {
        let row = [],
          cols = rowElement.querySelectorAll('td, th');
        for (const element of cols) row.push(element.innerText);

        csv.push(row.join(';'));
      }
    }

    this.downloadAsCSV(csv.join('\n'));
  }

  downloadAsCSV(string) {
    const csvFile = new Blob(['\uFEFF', string], { type: 'text/csv' });

    const downloadLink = document.createElement('a');
    downloadLink.download = 'Aspekte.csv';
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.click();
    downloadLink.remove();
  }
}
